import React from 'react';

const scaleSettings = {
  TEP: {
    max: 12.5,
    sections: [
      { label: 'Baixa', start: 0, end: 2, tone: 'low' },
      { label: 'Moderada', start: 2, end: 6, tone: 'moderate' },
      { label: 'Alta', start: 6, end: 12.5, tone: 'high' },
    ],
    ticks: [0, 2, 4, 6, 12.5],
  },
  TVP: {
    max: 9,
    sections: [
      { label: 'Baixa', start: 0, end: 1, tone: 'low' },
      { label: 'Moderada', start: 1, end: 3, tone: 'moderate' },
      { label: 'Alta', start: 3, end: 9, tone: 'high' },
    ],
    ticks: [0, 1, 2, 3, 9],
  },
};

function getCategory(total, type) {
  if (type === 'TEP') {
    if (total < 2) return { label: 'Baixa probabilidade', tone: 'low' };
    if (total <= 6) return { label: 'Moderada probabilidade', tone: 'moderate' };
    return { label: 'Alta probabilidade', tone: 'high' };
  }

  if (total <= 0) return { label: 'Baixa probabilidade', tone: 'low' };
  if (total <= 2) return { label: 'Moderada probabilidade', tone: 'moderate' };
  return { label: 'Alta probabilidade', tone: 'high' };
}

function ScoreRuler({ total, selectedItems, type }) {
  const settings = scaleSettings[type];
  const category = getCategory(total, type);
  const markerPosition = Math.min(100, Math.max(0, (total / settings.max) * 100));

  return (
    <section className="score-ruler" aria-label={`Régua de pontuação de ${type}`}>
      <div className="ruler-heading">
        <div>
          <h2>Como a pontuação se distribui?</h2>
          <p>Escala de 0 a {String(settings.max).replace(".", ",")} pontos para Wells {type}.</p>
        </div>
        <span className={`probability-pill tone-${category.tone}`}>
          {category.label}
        </span>
      </div>

      <div className="ruler-track-wrap">
        <div className="ruler-track" aria-label={`Pontuação atual: ${total}`}>
          {settings.sections.map((section) => (
            <div
              className={`ruler-segment tone-${section.tone}`}
              key={section.label}
              style={{ width: `${((section.end - section.start) / settings.max) * 100}%` }}
            >
              <span>{section.label}</span>
            </div>
          ))}
          {type === 'TEP' && (
            <span
              className="two-category-cut"
              style={{ left: `${(4 / settings.max) * 100}%` }}
              aria-label="Corte do modelo de duas categorias: 4 pontos"
            />
          )}
          <span
            className={`ruler-marker tone-${category.tone}`}
            style={{ left: `${markerPosition}%` }}
            aria-label={`Total de ${total} pontos`}
          >
            {total}
          </span>
        </div>
        <div className="ruler-ticks" aria-hidden="true">
          {settings.ticks.map((tick) => (
            <span key={tick} style={{ left: `${(tick / settings.max) * 100}%` }}>
              {String(tick).replace(".", ",")}
            </span>
          ))}
        </div>
      </div>

      {type === 'TEP' && (
        <p className="ruler-note">
          O traço em 4 pontos marca o corte do modelo de duas categorias; as
          faixas coloridas representam o modelo de três categorias.
        </p>
      )}

      <div className="score-equation" aria-live="polite">
        <span className="equation-label">Critérios marcados</span>
        {selectedItems.length ? (
          <div className="equation-items">
            {selectedItems.map((item) => (
              <span className="equation-item" key={item.id}>
                {item.points > 0 ? '+' : ''}
                {item.points}
              </span>
            ))}
            <span className="equation-total">= {total}</span>
          </div>
        ) : (
          <p>Nenhum critério selecionado ainda.</p>
        )}
      </div>
    </section>
  );
}

export default ScoreRuler;
